import Vue from 'vue'
import VueRouter from 'vue-router'
import { UserLayout, RouteView, MainLayout } from '@/components/layouts'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const files = require.context('./modules', true, /\.js$/)

const modules = files.keys().reduce((modules, modulePath) => {
  const value = files(modulePath)
  modules.push(value.default || value)
  return modules
}, [])

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home',
    component: MainLayout,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About.vue')
      },
      {
        path: '/mine',
        name: 'Mine',
        component: () => import('@/views/mine/Index.vue')
      }
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/user/Login')
      }
    ]
  },
  {
    path: '/',
    component: RouteView,
    hidden: true,
    children: [
      ...modules
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes
})

export default router
